import { render } from "./scope2ActivityRecorder.vue?vue&type=template&id=12ef3a10&ts=true"
import script from "./scope2ActivityRecorder.vue?vue&type=script&lang=ts"
export * from "./scope2ActivityRecorder.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__